import { createFileRoute } from '@tanstack/react-router';
import { useProject } from '@/features/projects/use-project';
import { requireResourcesFeature } from '@/features/resources/guard';
import { parseHeatmapSearch } from '@/features/resources/heatmap/heatmap-search';
import { ProjectResources } from '@/features/resources/heatmap/project-resources';

/** RES-09: resources of the project (resource.view; the API answers 403/404 otherwise). */
export const Route = createFileRoute('/_app/p/$projectKey/resources')({
  validateSearch: (raw: Record<string, unknown>) => parseHeatmapSearch(raw),
  beforeLoad: ({ context }) => requireResourcesFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const project = useProject(projectKey);
  return (
    <ProjectResources
      project={project}
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: next, replace: true });
      }}
    />
  );
}
